import { useCallback, useState, createContext, PropsWithChildren, useContext } from "react";
import { isNil } from "lodash-es";

type TempContext = {
  usesCelcius: boolean;
  setUsesCelcius: (s: boolean) => void;
}

const context = createContext<TempContext>({
  usesCelcius: true,
  setUsesCelcius: (_: boolean) => {},
});

export const celciusToFahrenheit = (val: number) => (val * 9 / 5) + 32;
export const fahrenheitToCelcius = (val: number) => (val - 32) * 5 / 9;

export const TempProvider = ({ children }: PropsWithChildren) => {
  const [usesCelcius, setUsesCelcius] = useState(true);
  return <context.Provider value={{ usesCelcius, setUsesCelcius }}>{children}</context.Provider>;
};

export const useTemp = () => useContext(context);

export const useTempUnits = () => {
  const { usesCelcius } = useTemp();
  const tempUnit = usesCelcius ? "C" : "F";
  const formatTemp = useCallback((val: number | undefined | null) => {
    if (isNil(val)) {
      return "0.0";
    }

    const adjusted = usesCelcius
      ? val
      : celciusToFahrenheit(val);

    return adjusted.toFixed(1);
  }, [usesCelcius]);

  return [tempUnit, formatTemp, usesCelcius] as const;
};
